import React, { useContext, useState } from 'react';
import { Store } from '../../store';

import {

  toggleLoading,
  toggleCategories,
  removeCategories,
  changePageAction,
  show1YCol, show3YCol
} from '../../actions';

export interface ProductFilterButtonProps {
  category: any
}

export function ProductFilterButton(props: ProductFilterButtonProps) {

  const { state, dispatch }: any = useContext(Store);

  const currentCategory = props.category;

  const [isCurrentActive, setActive] = useState(false);

  React.useEffect( () => {
    const results = state.filterCategories.find((c: any) => currentCategory.key.includes(Object.keys(c)[0]))

    if (results) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [state.filterCategories]);

  function onClickFilter (category: any, event: any) {

    let [ key, value ] = category.key.split(':')

    if (key === "performance_end_of_month_1_year") {
      removeCategories({
        id: "meilleurs-perf-3an",
        name: "Meilleures performances<br/>sur 3 ans",
        key: 'performance_end_of_month_3_years:1'
      }, state, dispatch);

      show1YCol(false, dispatch)
      show3YCol(true, dispatch)
    }
    else if (key === "performance_end_of_month_3_years") {
      removeCategories({
        id: "meilleurs-perf-1an",
        name: "Meilleures performances<br/>sur 1 an",
        key: 'performance_end_of_month_1_year:1'
      }, state, dispatch);

      show1YCol(true, dispatch)
      show3YCol(false, dispatch)
    }
    changePageAction(1, dispatch);
    toggleCategories(category, state, dispatch);
    toggleLoading(true, dispatch);

    event.preventDefault();
  }

  return (
    <button
      key={currentCategory.id}
      className={`btn btn-outline-primary btn-filter btn-${currentCategory.id} ${isCurrentActive ? 'active' : ''} w-100`}
      onClick={ (e) => onClickFilter (currentCategory, e) }
      dangerouslySetInnerHTML={{__html: currentCategory.name }}
    />
  );
}

ProductFilterButton.defaultProps = {
  category: {}
}
